import { size } from 'lodash';
import qs from 'qs';

export const doRequest = (key, searchObj, location, history, queryRequest) => {
  let query;

  switch (location.pathname) {
  case '/tickets':
    if (Number(key) === 0) {
      query = location.pathname;
    } else if (!size(searchObj)) {
      query = `${location.pathname}?${queryRequest}=${key}`;
    } else if (searchObj[queryRequest]) {
      searchObj[queryRequest] = key;
      query = `${location.pathname}?${qs.stringify(searchObj)}`;
    } else {
      query = `${location.pathname}${location.search}&${queryRequest}=${key}`;
    }
    history.push(query);
    break;

  case '/users':
    if (key === null) {
      delete searchObj.sort;
      delete searchObj.status;
      delete searchObj.page;
      query = `${location.pathname}?${location.search = qs.stringify(searchObj)}`;
    } else if (!size(searchObj)) {
      query = `${location.pathname}?${queryRequest}=${key}`;
    } else if (searchObj[queryRequest]) {
      delete searchObj.sort;
      delete searchObj.page;
      searchObj[queryRequest] = key;
      query = `${location.pathname}?${qs.stringify(searchObj)}`;
    } else {
      delete searchObj.page;
      searchObj[queryRequest] = key;
      query = `${location.pathname}${location.search}&${queryRequest}=${key}`;
    }
    history.push(query);
    break;

  case '/refill':
  case '/orders':
  case '/updates':
    if (key === null) {
      delete searchObj[queryRequest];
      query = `${location.pathname}?${(location.search = qs.stringify(searchObj))}`;
    } else if (!size(searchObj)) {
      query = `${location.pathname}?${queryRequest}=${key}`;
    } else if (searchObj[queryRequest]) {
      searchObj[queryRequest] = key;
      query = `${location.pathname}?${qs.stringify(searchObj)}`;
    } else {
      query = `${location.pathname}${location.search}&${queryRequest}=${key}`;
    }

    history.push(query);
    break;

  default:
    break;
  }
};
